<template>
  <div>
    <el-select
    :class="mode ? 'input__day' : 'input__night'"
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.branch')"
      filterable
      clearable
      :disabled="disabled"
      :size="size"
      class="d-block"
      :multiple="multiple"
    >
      <el-option
        v-for="(branch, index) in items"
        :key="'branches-' + index"
        :label="branch.name"
        :value="branch.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false      
    },
    company_id: {
      default: null,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
    company_id: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.selected = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.branches && this.branches.length === 0) this.updateInventory();
  },
  computed: {
    ...mapGetters({
      branches: "branch/inventory",
      mode:'MODE'
    }),
    items: function () {
      return !this.company_id
        ? this.branches
        : _.filter(this.branches, ["company_id", this.company_id]);
    },
  },
  methods: {
    ...mapActions({
      updateInventory: "branch/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
  },
};
</script>
